export default __webpack_public_path__ + "static/media/MP5_5.0738cd3f.png";